import {
  COMENZAR_EDICION_PEDIDORUTA,
  PEDIDORUTA_EDITADO_EXITO,
  PEDIDORUTA_EDITADO_ERROR,
  RESET_EDICION_PEDIDORUTA,
} from "../../redux/types";
import clienteAxios from "../../config/axios";
import { handlerError } from "../../utils/handlerError";

// Edita un registro en la api y state
export function editarPedidoRutaAction(pedido) {
  return async (dispatch) => {
    dispatch(editarPedidoRuta());
    await clienteAxios
      .post(`/rutas/updaterutaguia`, pedido, {
        headers: {
          "Content-Type": "multipart/form-data", 
        },
      })
      .then((respuesta) => {
        dispatch(editarPedidoRutaExito(respuesta.data));
      })
      .catch((err) => {
        dispatch(editarPedidoRutaError(handlerError(err)));
      });
  };
}

const editarPedidoRuta = () => ({
  type: COMENZAR_EDICION_PEDIDORUTA,
  payload: true,
});

const editarPedidoRutaExito = (pedido) => ({
  type: PEDIDORUTA_EDITADO_EXITO,
  payload: pedido,
});

const editarPedidoRutaError = (error) => ({
  type: PEDIDORUTA_EDITADO_ERROR,
  payload: error,
});

export function resetEditarPedidoRutaAction() {
  return async (dispatch) => {
    dispatch(resetEditarPedidoRuta());
  };
}

const resetEditarPedidoRuta = () => ({
  type: RESET_EDICION_PEDIDORUTA,
  payload: true,
});
